<template>
  <button
    v-if="hidden"
    type="button"
    class="flex h-full w-full items-center justify-center text-amber-700 hover:text-amber-900"
    title="Show queue"
    aria-label="Show the to-be-scheduled queue"
    @click="emit('toggle')"
  >
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M9 18l6-6-6-6" />
    </svg>
  </button>
  <span v-else class="flex w-full items-center gap-1.5 text-amber-900">
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="shrink-0 text-amber-700"
      aria-hidden="true"
    >
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
    <span>To be scheduled</span>
    <span v-if="!loading" class="inline-flex h-[18px] min-w-[20px] items-center justify-center rounded-full bg-amber-600 px-1.5 text-[10px] font-bold text-white">{{ count }}</span>
    <button
      type="button"
      class="ml-auto inline-flex rounded border border-amber-300 bg-white p-[3px] text-amber-700 hover:border-amber-700"
      title="Hide queue"
      aria-label="Hide the to-be-scheduled queue"
      @click="emit('toggle')"
    >
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  </span>
</template>

<script setup lang="ts">
  defineProps<{ count: number; hidden: boolean; loading: boolean }>();
  const emit = defineEmits<{ toggle: [] }>();
</script>
